'use client'

import React from 'react'
import Link from 'next/link'

// กำหนดชุดสีทึบแบบเดียวกับ meb (Solid vibrant colors with crisp white text)
const COLOR_BY_NAME = {
    'นิยายแปล': 'bg-[#00a651] hover:bg-[#008f45]',
    'แฟนตาซี': 'bg-[#a855f7] hover:bg-[#9333ea]',
    'โรแมนติก': 'bg-[#f59e0b] hover:bg-[#d97706]',
    'การเงินการลงทุน': 'bg-[#ec4899] hover:bg-[#db2777]',
    'นิยายรักจีนโบราณ': 'bg-[#fa8c16] hover:bg-[#d46b08]',
    'วรรณกรรมทั่วไป': 'bg-[#06b6d4] hover:bg-[#0891b2]',
    'กำลังภายใน': 'bg-[#ef4444] hover:bg-[#dc2626]',
    'ประวัติศาสตร์ ศาสนา วัฒนธรรม การเมืองการปกครอง': 'bg-[#2563eb] hover:bg-[#1d4ed8]',
    'จิตวิทยา พัฒนาตนเอง': 'bg-[#10b981] hover:bg-[#059669]',
    'การศึกษา': 'bg-[#6366f1] hover:bg-[#4f46e5]',
    'นิยายรัก': 'bg-[#00a651] hover:bg-[#008f45]',
    'การ์ตูน': 'bg-[#2563eb] hover:bg-[#1d4ed8]',
    'การ์ตูนทั่วไป': 'bg-[#2563eb] hover:bg-[#1d4ed8]',
    'การ์ตูนผู้หญิง': 'bg-[#06b6d4] hover:bg-[#0891b2]',
    'วาย/ยูริ': 'bg-[#ef4444] hover:bg-[#dc2626]',
    'โรมานซ์': 'bg-[#f59e0b] hover:bg-[#d97706]',
}

const FALLBACK_SOLID_COLORS = [
    'bg-[#00a651] hover:bg-[#008f45]', // เขียวมรกต
    'bg-[#f59e0b] hover:bg-[#d97706]', // เหลืองทอง
    'bg-[#fa8c16] hover:bg-[#d46b08]', // ส้มสด
    'bg-[#ef4444] hover:bg-[#dc2626]', // แดงคอรัล
    'bg-[#a855f7] hover:bg-[#9333ea]', // ม่วงสดใส
    'bg-[#2563eb] hover:bg-[#1d4ed8]', // น้ำเงินเข้ม
    'bg-[#06b6d4] hover:bg-[#0891b2]', // ฟ้าเทอร์คอยซ์
    'bg-[#10b981] hover:bg-[#059669]', // เขียวมิ้นต์
    'bg-[#ec4899] hover:bg-[#db2777]', // ชมพูบานเย็น
    'bg-[#6366f1] hover:bg-[#4f46e5]', // คราม/ม่วงน้ำเงิน
    'bg-[#ea580c] hover:bg-[#c2410c]', // ส้มอมแดง
    'bg-[#f43f5e] hover:bg-[#e11d48]', // กุหลาบแดง
]

const getCategoryColor = (name, index) => {
    if (name && COLOR_BY_NAME[name]) {
        return COLOR_BY_NAME[name]
    }
    // ค้นหาตามคำสำคัญที่ใกล้เคียง
    if (name) {
        if (name.includes('จีน')) return 'bg-[#fa8c16] hover:bg-[#d46b08]'
        if (name.includes('แฟนตาซี')) return 'bg-[#a855f7] hover:bg-[#9333ea]'
        if (name.includes('การเงิน') || name.includes('ลงทุน')) return 'bg-[#ec4899] hover:bg-[#db2777]'
        if (name.includes('จิตวิทยา') || name.includes('พัฒนาตนเอง')) return 'bg-[#10b981] hover:bg-[#059669]'
        if (name.includes('กำลังภายใน')) return 'bg-[#ef4444] hover:bg-[#dc2626]'
        if (name.includes('โรแมนติก') || name.includes('โรมานซ์')) return 'bg-[#f59e0b] hover:bg-[#d97706]'
        if (name.includes('การ์ตูน')) return 'bg-[#2563eb] hover:bg-[#1d4ed8]'
        if (name.includes('รัก')) return 'bg-[#00a651] hover:bg-[#008f45]'
    }
    return FALLBACK_SOLID_COLORS[index % FALLBACK_SOLID_COLORS.length]
}

export default function CategoryRow({ data }) {
    if (!data || !Array.isArray(data) || data.length === 0) return null
    // กรองเฉพาะหมวดหมู่ที่มีหนังสือ
    const activeData = data.filter(item => item.book_count == null || Number(item.book_count) > 0)
    if (activeData.length === 0) return null

    return (
        <div className="w-full my-4 md:my-6">
            {/* Header: ชื่อคอลัมน์ หมวดหมู่ + ดูทั้งหมด */}
            <div className="flex items-center justify-between pb-2">
                <h2 className="text-[20px] xl:text-[24px] font-semibold text-primary m-0">
                    หมวดหมู่
                </h2>
                <Link
                    href="/cate"
                    className="text-sm md:text-base text-[#00A896] hover:underline font-medium transition-colors"
                >
                    ดูทั้งหมด
                </Link>
            </div>

            {/* รายการหมวดหมู่แบบกล่องสีทึบสไตล์ meb (Solid Colorful Buttons) */}
            <div className="flex flex-wrap items-center gap-2 md:gap-2.5 mt-3">
                {activeData.map((item, index) => {
                    const colorClass = getCategoryColor(item.name, index)

                    return (
                        <Link
                            key={item.id ?? index}
                            href={`/cate/${item.id}`}
                            className={`px-3 md:px-4 py-1.5 rounded-[6px] md:rounded-[8px] text-white text-xs md:text-sm font-medium shadow-2xs hover:shadow-md hover:-translate-y-0.5 active:scale-95 transition-all duration-150 inline-flex items-center justify-center whitespace-nowrap text-decoration-none cursor-pointer ${colorClass}`}
                        >
                            {item.name}
                        </Link>
                    )
                })}
            </div>
        </div>
    )
}
